export default "__VITE_ASSET__CTqAPh8q__"